import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './Header.css';

function Header({ onOpenAuth, onToggleSidebar, sidebarOpen }) {
  const { user, isAuthenticated, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
  };

  return (
    <header className="app-header">
      <div className="header-container">
        <button 
          className="hamburger-button"
          onClick={onToggleSidebar}
          aria-label="Toggle menu"
          aria-expanded={sidebarOpen}
        >
          <span className="hamburger-icon">
            <span className="hamburger-line"></span>
          </span>
        </button>
        <div className="header-brand">
          <span className="header-icon"></span>
          <h1 className="header-title">Génération de Cours</h1>
        </div>

        <div className="header-actions">
          {isAuthenticated ? (
            <div className="user-menu">
              <button
                className="user-menu-button"
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <span className="user-email">{user?.email}</span>
                <span className="dropdown-icon"></span>
              </button>

              {showDropdown && (
                <div className="dropdown-menu">
                  <div className="dropdown-item dropdown-header">
                    <div className="user-info">
                      <p className="user-email-full">{user?.email}</p>
                      <p className="user-status">
                        {user?.isVerified ? 'Vérifié' : 'En attente de vérification'}
                      </p>
                    </div>
                  </div>
                  <div className="dropdown-divider"></div>
                  <button
                    className="dropdown-item dropdown-action"
                    onClick={handleLogout}
                  >
                    Déconnexion
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button className="login-button" onClick={onOpenAuth}>
              Se connecter
            </button>
          )}
        </div>
      </div>

      {/* Overlay pour fermer le dropdown en cliquant à l'extérieur */}
      {showDropdown && (
        <div
          className="dropdown-overlay"
          onClick={() => setShowDropdown(false)}
        ></div>
      )}
    </header>
  );
}

export default Header;
